export const CARD_DETAILS_FORM_ID = 'cardDetailsForm';
